// import { createRoot } from 'react-dom/client';

// // styles
// import './index.scss';

// // project-imports
// import App from './App';
// import { ConfigProvider } from 'contexts/ConfigContext';

// import '@fontsource/open-sans/300.css';
// import '@fontsource/open-sans/400.css';
// import '@fontsource/open-sans/500.css';
// import '@fontsource/open-sans/600.css';

// const container = document.getElementById('root');
// const root = createRoot(container);

// // ==============================|| MAIN - REACT DOM RENDER ||============================== //

// root.render(
//   <ConfigProvider>
//     <App />
//   </ConfigProvider>
// );

import { createRoot } from 'react-dom/client';
import { SWRConfig } from 'swr';

// styles
import './index.scss';
import './styles/listing.css';
import './styles/filter-panel.css';
import './styles/dropdowns.css';
import './styles/close-buttons.css';
// Add / Edit / View screens in Booking Management's pop-up look (.yz-form).
import './styles/form-shell.css';
// Dark mode's green-and-yellow finish: after the other styles, dark theme only.
import './styles/dark-theme.css';
import './styles/reactSelectDefaults';

import App from './App';
import { ConfigProvider } from './contexts/ConfigContext';
import AuthProvider from './context/AuthProvider';
import { swrFetcher } from './api/swrFetcher';

import 'temporal-polyfill/global';

import '@fontsource/open-sans/latin-300.css';
import '@fontsource/open-sans/latin-400.css';
import '@fontsource/open-sans/latin-500.css';
import '@fontsource/open-sans/latin-600.css';

// Self-heal after a frontend deploy.
//
// A build gives every lazy route a hashed filename (HomeRedirect-o9AZUymE.js).
// The next deploy replaces those files, so a tab that was already open — or one
// served a cached index.html — still asks for the old names, which 404. Vite
// raises `vite:preloadError`; we reload once to pick up the new build instead of
// stranding the user on "Something went wrong".
//
// Guarded by a timestamp so a genuine, repeating failure (offline, a truly
// broken chunk) surfaces the error rather than looping the page.
const CHUNK_RELOAD_KEY = 'chunk-reload-at';
window.addEventListener('vite:preloadError', (event) => {
  const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
  if (Date.now() - last < 10000) return; // just tried — let it surface
  event.preventDefault();
  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  window.location.reload();
});

const root = createRoot(document.getElementById('root'));

root.render(
  // <ConfigProvider>
  //   <AuthProvider>
  //     <SWRConfig
  //       value={{
  //         fetcher: swrFetcher,
  //         shouldRetryOnError: false,
  //         revalidateOnFocus: false,
  //         dedupingInterval: 1000
  //       }}
  //     >
  //       <App />
  //     </SWRConfig>
  //   </AuthProvider>
  // </ConfigProvider>
  <ConfigProvider>
    <SWRConfig
      value={{
        fetcher: swrFetcher,
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        dedupingInterval: 1000
      }}
    >
      <AuthProvider>
        <App />
      </AuthProvider>
    </SWRConfig>
  </ConfigProvider>
);
